import { GET_RESE_STORE_TABLE_DATA, GET_RESE_STORE_TABLE_DIVISION, GET_RESE_STORE_TABLE_BANNER, GET_RESE_STORE_TABLE_CITY,
GET_RESE_STORE_TABLE_STATE, GET_RESE_STORE_TABLE_STATUS, UPDATE_RESE_STORE_TABLE_DATA } from "./actionTypes";

const initialState = {
    reseStoreTableData: [],
    reseStoreTableDivisionData: [],
    reseStoreTableBannerData: [],
    reseStoreTableCityData: [],
    reseStoreTableStateData: [],
    reseStoreTableStatusData: [],
    totalRecords: 0,
    updateSuccess: false,
    updateError: null
}

const reseStoreReducer = (state = initialState, action={type: "", payload:null}) => {
    switch(action.type) {
        case GET_RESE_STORE_TABLE_DATA.SUCCESS:
            let { storeDataList, totalRecords } = action.payload;
            return {
                ...state,
                reseStoreTableData: storeDataList,
                totalRecords:totalRecords,
                updateSuccess: false,
                updateError: null

            }
        
        case UPDATE_RESE_STORE_TABLE_DATA.SUCCESS:
            return {
                ...state,
                updateSuccess: true,
                updateError: null
            }   

         case UPDATE_RESE_STORE_TABLE_DATA.ERROR:
                return {
                    ...state,
                    updateSuccess: false,
                    updateError: action.payload
                }      

        case GET_RESE_STORE_TABLE_DIVISION.SUCCESS:
            return {
                ...state,
                reseStoreTableDivisionData: action.payload
            }
        case GET_RESE_STORE_TABLE_BANNER.SUCCESS:
            return {
                ...state,
                reseStoreTableBannerData: action.payload
            }
        case GET_RESE_STORE_TABLE_CITY.SUCCESS:
            return {
                ...state,
                reseStoreTableCityData: action.payload
            }
        case GET_RESE_STORE_TABLE_STATE.SUCCESS:
            return {
                ...state,
                reseStoreTableStateData: action.payload
            }
        case GET_RESE_STORE_TABLE_STATUS.SUCCESS:
            return {
                ...state,
                reseStoreTableStatusData: action.payload
            }
        default:
            return state;
    }
}

export default reseStoreReducer;